import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a1408b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "person-page" }
const _hoisted_2 = { class: "timeline-area" }
const _hoisted_3 = {
  key: 0,
  class: "relation-path-area"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "list-label" }, "Children", -1))
const _hoisted_5 = {
  key: 0,
  class: "list-count"
}
const _hoisted_6 = {
  key: 1,
  class: "list-count-mini"
}
const _hoisted_7 = {
  key: 1,
  class: "empty-list"
}
const _hoisted_8 = {
  key: 2,
  class: "list-unstyled spouse-family-list"
}
const _hoisted_9 = { class: "list-unstyled person-list" }
const _hoisted_10 = { class: "primary-person-area" }
const _hoisted_11 = { class: "drawer-top" }
const _hoisted_12 = { class: "spouses-area" }
const _hoisted_13 = { class: "list-unstyled person-list" }
const _hoisted_14 = {
  key: 0,
  class: "marriage-year"
}
const _hoisted_15 = { class: "parent-area" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "list-label" }, "Parents")
], -1))
const _hoisted_17 = {
  key: 0,
  class: "empty-list"
}
const _hoisted_18 = { class: "list-unstyled parent-list" }
const _hoisted_19 = {
  key: 0,
  class: "list-unstyled other-parent-list"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-label" }, "stepmother", -1))
const _hoisted_21 = { class: "parent-family" }
const _hoisted_22 = { class: "marriage-year" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 1,
  class: "list-unstyled other-parent-list"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-label" }, "stepfather", -1))
const _hoisted_26 = { class: "sibling-area" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "list-label" }, "Siblings", -1))
const _hoisted_28 = {
  key: 0,
  class: "list-count"
}
const _hoisted_29 = {
  key: 1,
  class: "list-count-mini"
}
const _hoisted_30 = {
  key: 0,
  class: "empty-list"
}
const _hoisted_31 = {
  key: 1,
  class: "btn-group sibling-options",
  role: "group"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "siblingBirthOption",
  class: "btn btn-outline-secondary btn-sm"
}, "By birth", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "siblingFamilyOption",
  class: "btn btn-outline-secondary btn-sm"
}, "By family", -1))
const _hoisted_34 = { class: "list-unstyled sibling-family-list" }
const _hoisted_35 = { class: "list-unstyled person-list sibling-list" }
const _hoisted_36 = { class: "details-area" }
const _hoisted_37 = { class: "nav nav-pills person-tabs" }
const _hoisted_38 = { class: "nav-item" }
const _hoisted_39 = {
  type: "button",
  id: "highlightsTab",
  class: "nav-link",
  "data-bs-toggle": "tab",
  "data-bs-target": "#highlightsPane",
  role: "tab",
  "aria-controls": "highlightsPane",
  "aria-selected": "false"
}
const _hoisted_40 = {
  key: 0,
  class: "count"
}
const _hoisted_41 = { class: "nav-item" }
const _hoisted_42 = {
  type: "button",
  id: "detailsTab",
  class: "nav-link active",
  "data-bs-toggle": "tab",
  "data-bs-target": "#detailsPane",
  role: "tab",
  "aria-controls": "detailsPane",
  "aria-selected": "true"
}
const _hoisted_43 = { class: "nav-item" }
const _hoisted_44 = {
  type: "button",
  id: "contentTab",
  class: "nav-link",
  "data-bs-toggle": "tab",
  "data-bs-target": "#contentPane",
  role: "tab",
  "aria-controls": "contentPane",
  "aria-selected": "false"
}
const _hoisted_45 = {
  key: 0,
  class: "count"
}
const _hoisted_46 = {
  key: 1,
  class: "social-dot"
}
const _hoisted_47 = {
  id: "personContent",
  class: "tab-content person-details"
}
const _hoisted_48 = {
  id: "highlightsPane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelled-by": "highlightsTab",
  "tab-index": "0"
}
const _hoisted_49 = {
  id: "detailsPane",
  class: "tab-pane show active",
  role: "tabpanel",
  "aria-labelled-by": "detailsTab",
  "tab-index": "0"
}
const _hoisted_50 = {
  id: "contentPane",
  class: "tab-pane show",
  role: "tabpanel",
  "aria-labelled-by": "contentTab",
  "tab-index": "0"
}
const _hoisted_51 = { class: "earth-area" }

import { ref, Ref, computed, watch, nextTick, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { usePageTitle } from '@/util/AppUtil'
import { ViewPerson, ViewFamily, AssertionType, FamilyRelationshipRole } from '@/rd/ResearchDataModel'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { useViewFamilyStore, FamilyAndChildren } from '@/rd/ViewFamilyStore'
import { usePersonStore } from '@/rd/PersonStore'
import { useAssertionStore } from '@/rd/AssertionStore'
import { usePlaceStore } from '@/rd/PlaceStore'
import { useStandardPlaceStore } from '@/rd/StandardPlaceStore'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useExploreStore } from './ExploreStore'
import { SortDate } from '@/rd/SortDate'
import { CompositeId } from '@/rd/CompositeId'
import { LoadMode } from '@/util/AsyncData'
import { isDefined } from '@/util/TypeScriptUtil'
import { animate } from 'motion'
import { flatten, uniq } from 'lodash'
import Timeline from './time/Timeline.vue'
import RelationPath from './RelationPath.vue'
import OverlayButton from '@/util/OverlayButton.vue'
import PersonCard from "@/manage/PersonCard.vue"
import ProfileCard from "@/manage/ProfileCard.vue"
import SpouseConnector from '@/manage/SpouseConnector.vue'
import FamilyConnector from '@/manage/FamilyConnector.vue'
import PersonHighlights from "@/explore/highlights/PersonHighlights.vue"
import AssertionList from "@/explore/AssertionList.vue"
import ContentExplorer from "@/explore/content/ContentExplorer.vue"
import Earth from './Earth.vue'
import { AlignJustifyIcon, ImageIcon, PlusIcon, StarIcon } from '@zhuowenli/vue-feather-icons'
import { DOMUtil } from '@/util/DOMUtil'
import { useWindowSize } from '@vueuse/core'
import { LatLong } from '@/util/GeoUtil'

type SelectableItemType = 'ViewPerson' | 'ViewFamily' | 'Profile'

const animationDuration = 0.5


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonPage',
  props: {
  personId: String
},
  setup(__props) {

const props = __props;



const primaryPersonRef = ref<ViewPerson | undefined>(undefined)
const spouseFamiliesRef = ref([]) as Ref<FamilyAndChildren[]>
const spousesRef = ref([]) as Ref<ViewPerson[]>
const allChildrenCountRef = ref(0)
const uniqueParentFamiliesRef = ref([]) as Ref<FamilyAndChildren[]>
const otherParentFamiliesRef = ref([]) as Ref<FamilyAndChildren[]>
const allSiblingsRef = ref([]) as Ref<ViewPerson[]>

const relatedLoadedRef = ref(true)
const detailsLoadedRef = ref(true)
const showProfilesRef = ref(false)
const expandedAreaRef = ref<'left' | 'right'>()
const filterModeRef = ref(false)
const selectedItemTypeRef = ref<SelectableItemType | undefined>(undefined)
const selectedItemIdRef = ref<string | undefined>(undefined)
const showSiblingFamiliesRef = ref(false)
const earthModeRef = ref<'flat' | 'globe'>('globe')
const prevPersonPositions = new Map<string, DOMRect>()

const primaryCardRef = ref<InstanceType<typeof PersonCard>>()
const spouseCardsRef = ref<InstanceType<typeof PersonCard>[]>()
const childCardsRef = ref<InstanceType<typeof PersonCard>[]>()
const parentCardsRef = ref<InstanceType<typeof PersonCard>[]>()
const otherParentCardsRef = ref<InstanceType<typeof PersonCard>[]>()
const siblingCardsRef = ref<InstanceType<typeof PersonCard>[]>()
const personHighlightsRef = ref<InstanceType<typeof PersonHighlights>>()
const contentExplorerRef = ref<InstanceType<typeof ContentExplorer>>()
const earthRef = ref<InstanceType<typeof Earth>>()

const router = useRouter()
const { width: windowWidth } = useWindowSize()
const viewPersonStore = useViewPersonStore()
const viewFamilyStore = useViewFamilyStore()
const personStore = usePersonStore()
const assertionStore = useAssertionStore()
const placeStore = usePlaceStore()
const standardPlaceStore = useStandardPlaceStore()
const dataGroupStore = useDataGroupStore()
const exploreStore = useExploreStore()

const statusRef = ref('idle')
async function setStatus(value: string) {
  statusRef.value = value
  await nextTick()
}

usePageTitle("Person", () => primaryPersonRef.value?.displayName, true)

const isLargeScreenRef = computed(() => windowWidth.value > 768)

// ensure profile data groups are loaded so we can determine which profile matches to show
const profileIdsRef = computed(() => {
  const matches = personStore.getAsyncPersonList(primaryPersonRef.value?.matchIds ?? []).map(a => a.data).filter(isDefined)
  return matches.filter(p => (!p.profile && !p.restricted) || (p.profile && !p.placeholder))
    .map(p => p.id)
})

// NOTE: profile persons and their display properties are all loaded in a single request with the assertions, so
// no need to load them separately for the profile cards

// track loading of person assertions to determine an alternative focus place in case we can't use birth place 
// available on view person display properties
const birthPlaceRef = computed(() => placeStore.trackAsyncPlace(primaryPersonRef.value?.displayProperties.birthPlaceId)?.data)
const deathPlaceRef = computed(() => placeStore.trackAsyncPlace(primaryPersonRef.value?.displayProperties.deathPlaceId)?.data)
const focusPlaceRef = computed(() => birthPlaceRef.value ?? deathPlaceRef.value)

const spouseFamiliesWithChildrenRef = computed(() => spouseFamiliesRef.value.filter(sf => sf.childIds.length > 0))
const showSiblingFamiliesOptionRef = computed(() => uniqueParentFamiliesRef.value.length > 1 || otherParentFamiliesRef.value.length > 0)
const siblingFamiliesRef = computed(() => {
  const allNonEmptyFamilies = [...uniqueParentFamiliesRef.value, ...otherParentFamiliesRef.value]
      .filter(sf => sf.childIds.length > 0)

  if (allNonEmptyFamilies.length > 1 && !showSiblingFamiliesRef.value) {
    const combinedFamily = {
      family: allNonEmptyFamilies[0].family, // re-use first family as placeholder for display
      childIds: allSiblingsRef.value.map(s => s.id) 
    } as FamilyAndChildren
    return [combinedFamily]
  }
  return allNonEmptyFamilies
})

// TODO: Use localization to pluralize
const parentFamiliesTextRef = computed(() => uniqueParentFamiliesRef.value.length > 1 ? "families" : "family")

function showChildMoreIndicator(childId: string, familyId: string) { 
  return hasDescendants(childId) && isPrimaryChildInstance(childId, familyId)
}

function isPrimaryChildInstance(childId: string, familyId: string) {
  // treat first occurrence of child as "primary"
  return spouseFamiliesRef.value.find(sf => sf.childIds.includes(childId))?.family.id == familyId
}

function getSpouseFamilyName(sf: FamilyAndChildren) {
  return spousesRef.value.find(sp => sp.id == sf.family.spouseOf(props.personId!))?.displayName
}

function getOtherSpousesOf(pf: FamilyAndChildren, role: FamilyRelationshipRole) {
  const parentId = pf.family.getSpouseId(role)
  if (!parentId)
    return []

  const exceptSpouseId = pf.family.spouseOf(parentId)
  return otherParentFamiliesRef.value.filter(pf => pf.family.hasSpouse(parentId))
    .map(pf => pf.family.spouseOf(parentId))
    .filter(id => id != exceptSpouseId)
}

function getSiblingFamilyName(sf: FamilyAndChildren) {
  const fatherName = viewPersonStore.getAsyncPerson(sf.family.fatherId)?.data?.displayName
  const motherName = viewPersonStore.getAsyncPerson(sf.family.motherId)?.data?.displayName
  if (uniqueParentFamiliesRef.value.includes(sf)) {
    return `${fatherName} and ${motherName}`
  }
  else {
    return sf.family.fatherId && uniqueParentFamiliesRef.value.find(pf => pf.family.hasSpouse(sf.family.fatherId!))
      ? motherName : fatherName
  }
}

function isSelected(itemId: string, itemType: SelectableItemType) {
  return selectedItemTypeRef.value == itemType && selectedItemIdRef.value == itemId
}

function selectItem(itemId: string | undefined, itemType: SelectableItemType) {
  filterModeRef.value = !!itemId
  selectedItemTypeRef.value = itemType
  selectedItemIdRef.value = itemId
}

function isFamilySelected(f: FamilyAndChildren) {
  return isSelected(f.family.id!, 'ViewFamily')
}

function toggleSelectSpouseFamily(sf: FamilyAndChildren) {
  const select = enableSelectSpouseRef.value && !isSelected(sf.family.id!, 'ViewFamily') // toggle if enabled, otherwise clear selection
  selectItem(select ? sf.family.id : undefined, 'ViewFamily')
}

function toggleSelectParentFamily(pf: FamilyAndChildren) {
  const select = enableSelectParentsRef.value && !isSelected(pf.family.id!, 'ViewFamily') // toggle if enabled, otherwise clear selection
  selectItem(select ? pf.family.id : undefined, 'ViewFamily')
}

function clearSelection() {
  selectItem(undefined, 'ViewFamily')
}

function isPrimaryPerson(personId: string) {
  return personId == primaryPersonRef.value?.id
}

function showMarriageYear(family: ViewFamily) {
  return isLargeScreenRef.value && !!getMarriageYear(family)
}

function getMarriageYear(family: ViewFamily) {
  return family.displayProperties.marriageDate.date1?.year
}

const enableSelectSpouseRef = computed(() => spouseFamiliesRef.value.length > 1)
const enableSelectParentsRef = computed(() => uniqueParentFamiliesRef.value.length > 1)

function onFamilySelectedChange(f: FamilyAndChildren, e: Event) {
  const checkbox = e.target as HTMLInputElement
  selectItem(checkbox.checked ? f.family.id : undefined, 'ViewFamily')
}

function isFamilyDimmed(f: FamilyAndChildren) {
  return filterModeRef.value && !isSelected(f.family.id!, 'ViewFamily')
}

function isChildInFilter(childId: string) {
  return spouseFamiliesRef.value.find(sf => isFamilySelected(sf))?.childIds.includes(childId)
}

function isSiblingInFilter(siblingId: string) {
  return uniqueParentFamiliesRef.value.find(pf => isFamilySelected(pf))?.childIds.includes(siblingId)
}

function hasDescendants(personId: string | undefined) {
  return personId && viewPersonStore.hasLoadedDescendants(personId)
}

function hasAncestors(personId: string | undefined) {
  return personId && viewPersonStore.hasLoadedAncestors(personId)
}

function isRelatedChild(childId: string | undefined) {
  return childId && childId != exploreStore.startPersonId && exploreStore.relationPath?.startPersonPath.some(pi => pi.ancestorId == childId)
}

function isRelatedParent(parentId: string | undefined) {
  return parentId && parentId != exploreStore.startPersonId && (
    exploreStore.relationPath?.toPersonPath.some(pi => pi.ancestorId == parentId) ||
    (exploreStore.relationPath?.commonAncestorId == parentId && exploreStore.relationPath?.startPersonPath.length == 0))
}

const isLeftAreaExpandedRef = computed(() => isLargeScreenRef.value || expandedAreaRef.value == 'left')
const isRightAreaExpandedRef = computed(() => isLargeScreenRef.value || expandedAreaRef.value == 'right')

const leftCardLayoutRef = computed(() => isLargeScreenRef.value ? 'small' : isLeftAreaExpandedRef.value ? 'tiny' : 'dot')
const primaryCardLayoutRef = computed(() => !isLargeScreenRef.value && expandedAreaRef.value ? 'small' : 'full')
const spouseCardLayoutRef = computed(() => expandedAreaRef.value ? 'tiny' : 'small')
const rightCardLayoutRef = computed(() => isLargeScreenRef.value ? 'small' : isRightAreaExpandedRef.value ? 'tiny' : 'dot')

function expandLeftArea(expand: boolean) {
  expandedAreaRef.value = expand ? 'left' : undefined
}

function expandRightArea(expand: boolean) {
  expandedAreaRef.value = expand ? 'right' : undefined
}

function onPrimaryClick() {
  expandedAreaRef.value = undefined
}

function onPrimaryClickImage(contentId: string) {
  contentExplorerRef.value?.showContent(contentId)
}

watch(isLargeScreenRef, () => {
  if (isLargeScreenRef.value) {
    expandedAreaRef.value = undefined
  }
})

function savePrevPosition(card: InstanceType<typeof PersonCard>) {
  const el = card?.$el as HTMLElement
  if (el && !el.classList.contains('card-placeholder')) {
    const oldPosition = el.getBoundingClientRect()
    const personId = el.dataset.id!
    prevPersonPositions.set(personId, oldPosition)
  }
}

watch(props, async () => {
  await setStatus("Saving card positions")
  // capture positions of all persons currently displayed
  prevPersonPositions.clear()
  if (primaryPersonRef.value?.id) {
    savePrevPosition(primaryCardRef.value!)
  }
  const personCards = [
    ...(childCardsRef.value ?? []),
    ...(spouseCardsRef.value ?? []),
    ...(parentCardsRef.value ?? []),
    ...(otherParentCardsRef.value ?? []),
    ...(siblingCardsRef.value ?? []),
  ]
  for (const c of personCards) {
    savePrevPosition(c)
  }

  console.log("PersonPage: all previous person positions saved")

  // reset interactive state
  showProfilesRef.value = false
  filterModeRef.value = false
  selectedItemTypeRef.value = undefined
  selectedItemIdRef.value = undefined

  relatedLoadedRef.value = false
  detailsLoadedRef.value = false

  if (!props.personId)
    return

  await setStatus("Start loading details")

  // load  primary person details and user location
  const loadDetails = viewPersonStore.ensureDetailsLoadedAsync(props.personId)

  await setStatus("Loading generations")
  // pre-load extra generations of ancestors and descendants so, once loaded, user can navigate 
  // immediately to any visible person (don't wait if not needed yet)
  const loadRelated = Promise.allSettled([
    // if user navigates to a parent, sibling, or child, need THEIR parents, siblings, and children
    // pre-loaded for display, and their grandparents and grandchildren loaded for "more" indicators
    viewPersonStore.ensureAncestorsLoadedAsync([props.personId], 3, 2),
    viewPersonStore.ensureDescendantsLoadedAsync(props.personId, 2),
  ])

  // wait to display page if related persons are not loaded
  const ancestorsLoaded = viewPersonStore.areAncestorsLoaded(props.personId, 1, 1)
  const descendantsLoaded = viewPersonStore.areDescendantsLoaded(props.personId, 1)
  console.log(`PersonPage: ancestors loaded: ${ancestorsLoaded}, descendants loaded: ${descendantsLoaded}`)
  if (!ancestorsLoaded || !descendantsLoaded) {
    await loadRelated
    const ancestorsLoadedFinal = viewPersonStore.areAncestorsLoaded(props.personId, 1, 1)
    const descendantsLoadedFinal = viewPersonStore.areDescendantsLoaded(props.personId, 1)
    console.log(`PersonPage: ancestors loaded: ${ancestorsLoadedFinal}, descendants loaded: ${descendantsLoadedFinal}`)
    relatedLoadedRef.value = true
  }
  else {
    loadRelated.then(() => {
      if (props.personId &&
          viewPersonStore.areAncestorsLoaded(props.personId, 2, 1) && 
          viewPersonStore.areDescendantsLoaded(props.personId, 2)) {
        // we now have enough information to show more indicators
        relatedLoadedRef.value = true
      }
    })
  }

  const spouseFamilies = viewFamilyStore.getLoadedSpouseFamilies(props.personId).spouseFamilies
    .filter(sf => isVisibleViewPerson(sf.spouseOf(props.personId!)))

  console.log(`PersonPage: spouse families found: ${spouseFamilies.length}`)

  await setStatus("Start loading family details")
  // ensure spouse family assertions loaded (don't wait)
  const spouseFamilyIds = spouseFamilies.map(sf => sf.id!)
  await Promise.all([
    loadDetails,
    ...spouseFamilyIds.map(id => viewFamilyStore.ensureAssertionsLoadedAsync(id))
  ])
  detailsLoadedRef.value = true

  await setStatus("Start loading spouse generations")
  // pre-load spouse ancestors and descendants (don't wait)
  for (const sf of spouseFamilies) {
    viewPersonStore.ensureAncestorsLoadedAsync([sf.spouseOf(props.personId)], 1, 1)
    viewPersonStore.ensureDescendantsLoadedAsync(sf.spouseOf(props.personId), 1)
  }

  // got everything we need, so start updating reactive state
  console.log(`PersonPage: updating reactive state`)

  // should be loaded prior to navigation in most cases (except e.g. initial load from a deep link)
  const primaryPerson = viewPersonStore.getAsyncPerson(props.personId)?.data
  if (!primaryPerson) {
    console.log(`PersonPage: primary person not found`)
    return
  }

  if (primaryPerson.id != props.personId) {
    // redirect to canonical URL for this view person
    router.replace(primaryPerson.pageUrl!)
    return
  }

  const familyChildrenMap = new Map<string, string[]>()
  for (const sf of spouseFamilies) {
    const childIds = viewFamilyStore.asyncChildKeys.get(sf.id!)?.data?.keys ?? []
    familyChildrenMap.set(sf.id!, childIds.filter(id => isVisibleViewPerson(id)))
  }
  // TODO: how to sort multiple families?
  const allChildIds = uniq(flatten(Array.from(familyChildrenMap.values()))) // preserve child order within families
  console.log(`PersonPage: children found: ${allChildIds.length}`)

  const parentFamilies = viewPersonStore.getLoadedParentFamilies(props.personId!).parentFamilies
    .filter(pf => pf.spouseIds.some(id => isVisibleViewPerson(id)))
  const parentFamilyIds = parentFamilies.map(pf => pf.id!)
  console.log(`PersonPage: parent families found: ${parentFamilies.length}`)
  // TODO: how to sort parent families?

  // only show parent families that have NO spouses in common with a previous parent family
  const uniqueParentFamilies = [] as ViewFamily[]
  const parentIds = [] as string[]
  for (const pf of parentFamilies) {
    if (!pf.spouseIds.some(id => parentIds.includes(id))) {
      uniqueParentFamilies.push(pf)
      parentIds.push(...pf.spouseIds)
    }
  }
  const uniqueParentFamilyIds = uniqueParentFamilies.map(f => f.id!)

  const otherParentFamilyIds = parentIds.flatMap(id => viewPersonStore.asyncSpouseFamilyKeys.get(id)?.data?.keys ?? []) // should be loaded
    .filter(famId => !uniqueParentFamilyIds.includes(famId))
  const otherParentFamilies = otherParentFamilyIds.map(id => viewFamilyStore.asyncViewFamilies.get(id)?.data)
    .filter(isDefined)

  const allParentFamilyIds = [...uniqueParentFamilyIds, ...otherParentFamilyIds]
  const familySiblingMap = new Map<string, string[]>()
  for (const pfId of allParentFamilyIds) {
    const siblingIds = viewFamilyStore.asyncChildKeys.get(pfId)?.data?.keys ?? []
    familySiblingMap.set(pfId, siblingIds.filter(id => isVisibleViewPerson(id)))
  }
  const allSiblingIds = uniq(flatten(Array.from(familySiblingMap.values()))) // preserve child order within families
  const allSiblings = viewPersonStore.getAsyncPersonList(allSiblingIds)
    .map(a => a.data).filter(isDefined)
    .sort((a, b) => SortDate.compare(a.displayProperties.birthSortDate, b.displayProperties.birthSortDate))
  console.log(`PersonPage: siblings found: ${allSiblings.length}`)

  const spouseFamiliesAndChildren = spouseFamilies
    .map(sf => ({ family: sf, childIds: familyChildrenMap.get(sf.id!) ?? [] }))
    .sort((a, b) => SortDate.compare(a.family.displayProperties.marriageSortDate, b.family.displayProperties.marriageSortDate))
  const spouses = viewPersonStore.getAsyncPersonList(spouseFamilies.map(sf => sf.spouseOf(props.personId!)))
    .map(a => a.data).filter(isDefined)
  const uniqueParentFamiliesAndChildren = uniqueParentFamilies
    .map(pf => ({ family: pf, childIds: familySiblingMap.get(pf.id!) ?? [] }))
  const otherParentFamiliesAndChildren = otherParentFamilies
    .map(pf => ({ family: pf, childIds: familySiblingMap.get(pf.id!) ?? [] }))

  // ensure all data groups (and owners) get loaded, but don't wait for them
  const matchIds = primaryPerson?.matchIds ?? []
  const allPersonAndFamilyIds = [matchIds, spouseFamilyIds, allChildIds, parentFamilyIds, allSiblingIds].flat()
  const allGroupIds = [...new Set(allPersonAndFamilyIds.map(CompositeId.getGroupId))]
  const asyncGroups = dataGroupStore.getAsyncGroupList(allGroupIds, LoadMode.EnsureLoaded)
  console.log(`PersonPage: data groups found: ${allGroupIds.length}, loaded: ${asyncGroups.filter(a => a.isLoadComplete()).length}`)

  const newPersonIds = new Set([
    props.personId, 
    ...spouseFamilies.map(sf => sf.spouseOf(props.personId!)),
    ...allChildIds,
    ...uniqueParentFamilies.flatMap(pf => pf.spouseIds),
    ...allSiblingIds].filter(isDefined))

  await setStatus("Animating out")
  await animatePersonsOutAsync(newPersonIds)

  // update reactive state
  primaryPersonRef.value = primaryPerson
  spouseFamiliesRef.value = spouseFamiliesAndChildren
  spousesRef.value = spouses
  allChildrenCountRef.value = allChildIds.length
  uniqueParentFamiliesRef.value = uniqueParentFamiliesAndChildren
  otherParentFamiliesRef.value = otherParentFamiliesAndChildren
  allSiblingsRef.value = allSiblings

  // update layout
  expandedAreaRef.value = undefined

  // allow Vue to update DOM before we try to animate new/moved elements
  //await nextTick()
  await setStatus("Animating in")

  animatePersonsIn()

}, { immediate: true })

function isVisibleViewPerson(personId: string | undefined) {
  if (personId) {
    const vp = viewPersonStore.getLoadedPerson(personId)
    const matches = personStore.getLoadedPersonList(vp?.matchIds ?? [])
    return matches.some(p => !p.placeholder && !p.restricted)
  }
  return true // empty references (e.g. to unknown spouse) remain "visible"
}

async function animatePersonsOutAsync(newPersonIds: Set<string>) {
  const finished: (Promise<void> | undefined)[] = []
  
  const oldPrimaryPersonId = primaryPersonRef.value?.id
  if (oldPrimaryPersonId && !newPersonIds.has(oldPrimaryPersonId)) {
    // zoom + fade out
    const ac = animate(primaryCardRef.value!.$el, 
      { opacity: [1, 0] },
      { duration: animationDuration, easing: "ease-in" }
    )
    finished.push(ac.finished)
  }

  // TODO: animate placeholders correctly (should fade out in-place)
  
  let childrenChanged = false
  for (const c of childCardsRef.value ?? []) {
    const personId = c.$el.dataset.id!
    if (personId && !newPersonIds.has(personId)) {
      const ac = animatePersonOut(c.$el, "left")
      finished.push(ac.finished)
      childrenChanged = true
    }
  }

  if (childrenChanged) {
    //finished.push(fadeOut(".children-area .spouse-family-header")?.finished)
    finished.push(fadeOut(".children-area .more-indicator")?.finished)
  }

  for (const c of spouseCardsRef.value ?? []) {
    const personId = c.$el.dataset.id!
    if (personId && !newPersonIds.has(personId)) {
      const ac = animatePersonOut(c.$el)
      finished.push(ac.finished)
    }
  }

  finished.push(fadeOut(".spouses-area .spouse-connector")?.finished)
  finished.push(fadeOut(".spouses-area .marriage-year")?.finished)

  const rightCards = [
    ...(parentCardsRef.value ?? []),
    ...(otherParentCardsRef.value ?? []),
    ...(siblingCardsRef.value ?? [])
  ]
  let rightCardsChanged = false
  for (const c of rightCards) {
    const personId = c.$el.dataset.id!
    if (personId && !newPersonIds.has(personId)) {
      const ac = animatePersonOut(c.$el, "right")
      finished.push(ac.finished)
      rightCardsChanged = true
    }
  }

  if (rightCardsChanged) {
    finished.push(fadeOut(".parent-list .spouse-connector")?.finished)
    finished.push(fadeOut(".parent-list .parent-fam-connector")?.finished)
    finished.push(fadeOut(".parent-list .marriage-year")?.finished)
    //finished.push(fadeOut(".sibling-area .spouse-family-header")?.finished)
    finished.push(fadeOut(".parent-fam-area .more-indicator")?.finished)
  }

  return Promise.all(finished)
}

function animatePersonOut(el: HTMLElement, direction?: 'left' | 'right') {
  const personId = el.dataset.id!
  console.log(`PersonPage: personOut: ${viewPersonStore.getAsyncPerson(personId)?.data?.displayName}`)
  const index = parseInt(el.dataset.index!)

  if (!direction) {
    return animate(el,
      { width: [null, "50%"], height: [null, "50%"], opacity: [1, 0] },
      { duration: animationDuration / 2, easing: "ease-in" }
    )
  }

  const dx = direction == "left" ? -100 : 100
  return animate(el,
    { x: dx, opacity: [1, 0] },
    { duration: animationDuration / 2, easing: 'linear' }
  )
}

function fadeOut(selector: string) {
  // HACK: animate complains if selector doesn't match anything, so check first
  const elements = document.querySelectorAll(selector)
  if (elements.length == 0) {
    return undefined
  }
  
  return animate(selector,
    { opacity: [1, 0, 0] },
    { duration: animationDuration / 2, easing: "linear" })
}

function animatePersonsIn() {
  animatePersonIn(primaryCardRef.value!.$el)

  // TODO: animate placeholders correctly (should fade in in-place)

  let childrenChanged = false
  for (const c of childCardsRef.value ?? []) {
    if (animatePersonIn(c.$el, "left")) {
      childrenChanged = true
    }
  }
  if (childrenChanged) {
    //fadeIn(".children-area .spouse-family-header")
    fadeIn(".children-area .more-indicator")
  }

  for (const c of spouseCardsRef.value ?? []) {
    animatePersonIn(c.$el, "left")
  }

  let parentsChanged = false
  const allParentCards = [
    ...(parentCardsRef.value ?? []), 
    ...(otherParentCardsRef.value ?? [])
  ]
  for (const c of allParentCards) {
    if (animatePersonIn(c.$el, "right")) {
      parentsChanged = true
    }
  }

  for (const c of siblingCardsRef.value ?? []) {
    animatePersonIn(c.$el, "right")
  }

  fadeIn(".spouses-area .spouse-connector")
  fadeIn(".spouses-area .marriage-year")
  if (parentsChanged) {
    fadeIn(".parent-list .parent-fam-connector")
    fadeIn(".parent-list .marriage-year")
    //fadeIn(".sibling-area .spouse-family-header")
    fadeIn(".parent-fam-area .more-indicator")
  }
}

function animatePersonIn(el: HTMLElement, direction?: "left" | "right") {
  const personId = el.dataset.id!
  const oldPosition = prevPersonPositions.get(personId)
  if (oldPosition) {
    const newPosition = el.getBoundingClientRect()
    if (DOMUtil.rectEquals(newPosition, oldPosition)) {
      return undefined // no change
    }
    // slide from old to new position (scale if needed)
    const dx = oldPosition.left - newPosition.left
    const dy = oldPosition.top - newPosition.top
    const dw = oldPosition.width / newPosition.width
    const dh = oldPosition.height / newPosition.height
    const opacityKeyframes = (dw == 1 && dh == 1) ? [1, 1] : [0.5, 1]
    el.style.transformOrigin = "top left"
    return animate(el,
      { x: [dx, 0], y: [dy, 0], scaleX: [dw, 1], scaleY: [dh, 1], opacity: opacityKeyframes },
      { duration: animationDuration, easing: 'ease-out' })
  }
  else if (direction) {
    // slide + fade in from direction
    const dx = direction == "left" ? -100 : 100
    return animate(el,
      { x: [dx, 0], opacity: [0, 1] },
      { duration: animationDuration, easing: 'ease-in' }
    )
  }
  else {
    // zoom + fade in from center
    el.style.transformOrigin = "center"
    return animate(el, 
      { scale: [0.5, 1], opacity: [0, 1] },
      { duration: animationDuration, easing: "ease-out" })
  }
}

function fadeIn(selector: string) {
  // HACK: animate complains if selector doesn't match anything, so check first
  const elements = document.querySelectorAll(selector)
  if (elements.length == 0) {
    return undefined
  }

  return animate(selector,
    { opacity: [0, 1] },
    { delay: animationDuration, duration: 0.3, easing: "ease-out" })
}

onMounted(() => exploreStore.hasViewedTree = true )

watch(focusPlaceRef, async () => {
  earthRef.value?.removeMarker('focus')
  if (focusPlaceRef.value) {
    let location: Partial<LatLong> = focusPlaceRef.value
    if (!location.latitude || !location.longitude) {
      const places = await standardPlaceStore.getBestPlacesAsync([focusPlaceRef.value.name])
      location = places.at(0)?.place ?? {}
    }
    if (location.latitude && location.longitude) {
      console.log(`PersonPage: move earth to marker at ${focusPlaceRef.value.name} (${location.latitude.toFixed(5)}, ${location.longitude.toFixed(5)})`)
      earthRef.value?.addMarker('focus', location as LatLong)
      earthRef.value?.moveTo(location as LatLong)
    }
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Timeline, {
        personId: primaryPersonRef.value?.id
      }, null, 8, ["personId"])
    ]),
    (primaryPersonRef.value?.id != _unref(exploreStore).startPersonId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(RelationPath, {
            "person-id": primaryPersonRef.value?.id
          }, null, 8, ["person-id"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["children-area", { expanded: isLeftAreaExpandedRef.value }])
    }, [
      (!isLeftAreaExpandedRef.value)
        ? (_openBlock(), _createBlock(OverlayButton, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (expandLeftArea(true)))
          }))
        : _createCommentVNode("", true),
      _createElementVNode("h4", null, [
        _hoisted_4,
        (allChildrenCountRef.value > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(" + _toDisplayString(allChildrenCountRef.value) + ")", 1))
          : _createCommentVNode("", true),
        (allChildrenCountRef.value > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(allChildrenCountRef.value), 1))
          : _createCommentVNode("", true)
      ]),
      (spouseFamiliesWithChildrenRef.value.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, " None "))
        : (_openBlock(), _createElementBlock("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(spouseFamiliesWithChildrenRef.value, (sf) => {
              return (_openBlock(), _createElementBlock("li", {
                key: sf.family.id
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["spouse-family-header", { show: spouseFamiliesWithChildrenRef.value.length > 1 }])
                }, _toDisplayString(getSpouseFamilyName(sf)) + " (" + _toDisplayString(sf.childIds.length) + ") ", 3),
                _createElementVNode("ul", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sf.childIds, (id, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: id }, [
                      (showChildMoreIndicator(id, sf.family.id!))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["more-indicator", { related: isRelatedChild(id) }])
                          }, [
                            _createVNode(_unref(PlusIcon))
                          ], 2))
                        : _createCommentVNode("", true),
                      _createVNode(PersonCard, {
                        ref_for: true,
                        ref_key: "childCardsRef",
                        ref: childCardsRef,
                        "person-id": id,
                        layout: leftCardLayoutRef.value,
                        disabled: !isPrimaryChildInstance(id, sf.family.id!),
                        "data-id": id,
                        "data-index": index
                      }, null, 8, ["person-id", "layout", "disabled", "data-id", "data-index"])
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ]))
    ], 2),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(PersonCard, {
          "person-id": primaryPersonRef.value?.id,
          ref_key: "primaryCardRef",
          ref: primaryCardRef,
          layout: primaryCardLayoutRef.value,
          raised: "",
          style: _normalizeStyle({ opacity: primaryPersonRef.value ? 1 : 0 }),
          "data-id": primaryPersonRef.value?.id,
          "select-mode": !!expandedAreaRef.value,
          "show-profile-count": "always",
          onClick: onPrimaryClick,
          onClickImage: onPrimaryClickImage,
          onShowProfiles: _cache[1] || (_cache[1] = ($event: any) => (showProfilesRef.value = !showProfilesRef.value))
        }, null, 8, ["person-id", "layout", "style", "data-id", "select-mode"])
      ]),
      (!expandedAreaRef.value)
        ? (_openBlock(), _createElementBlock("ul", {
            key: 0,
            class: _normalizeClass(["list-unstyled drawer-stack profiles-list", { show: showProfilesRef.value }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileIdsRef.value, (id) => {
              return (_openBlock(), _createElementBlock("li", { key: id }, [
                _createVNode(ProfileCard, {
                  "person-id": id,
                  "show-profile-type": ""
                }, null, 8, ["person-id"])
              ]))
            }), 128))
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("ul", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(spouseFamiliesRef.value, (sf, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: sf.family.id
            }, [
              _createVNode(SpouseConnector, {
                layout: spouseCardLayoutRef.value,
                dimmed: isFamilyDimmed(sf)
              }, null, 8, ["layout", "dimmed"]),
              _createVNode(PersonCard, {
                ref_for: true,
                ref_key: "spouseCardsRef",
                ref: spouseCardsRef,
                "person-id": sf.family.spouseOf(primaryPersonRef.value!.id!),
                layout: spouseCardLayoutRef.value,
                "data-id": sf.family.spouseOf(primaryPersonRef.value!.id!),
                "data-index": index
              }, null, 8, ["person-id", "layout", "data-id", "data-index"]),
              (showMarriageYear(sf.family))
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", null, "m. " + _toDisplayString(getMarriageYear(sf.family)), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["parent-fam-area", { expanded: isRightAreaExpandedRef.value }])
    }, [
      (!isRightAreaExpandedRef.value)
        ? (_openBlock(), _createBlock(OverlayButton, {
            key: 0,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (expandRightArea(true)))
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        (uniqueParentFamiliesRef.value.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, " None "))
          : _createCommentVNode("", true),
        _createElementVNode("ul", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueParentFamiliesRef.value, (pf, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: pf.family.id
            }, [
              (getOtherSpousesOf(pf, _unref(FamilyRelationshipRole).Father).length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getOtherSpousesOf(pf, _unref(FamilyRelationshipRole).Father), (id, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: id }, [
                        _createVNode(SpouseConnector, { layout: rightCardLayoutRef.value }, null, 8, ["layout"]),
                        _createVNode(PersonCard, {
                          ref_for: true,
                          ref_key: "otherParentCardsRef",
                          ref: otherParentCardsRef,
                          personId: id,
                          layout: rightCardLayoutRef.value,
                          "data-id": id,
                          "data-index": index
                        }, null, 8, ["personId", "layout", "data-id", "data-index"]),
                        (relatedLoadedRef.value && hasAncestors(id))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["more-indicator", { related: isRelatedParent(id) }])
                            }, [
                              _createVNode(_unref(PlusIcon))
                            ], 2))
                          : _createCommentVNode("", true),
                        _hoisted_20
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(FamilyConnector, {
                  layout: rightCardLayoutRef.value,
                  dimmed: isFamilyDimmed(pf),
                  spacer: ""
                }, null, 8, ["layout", "dimmed"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([pf.family.fatherId], (id) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: id,
                    class: "parent-fam-spouse"
                  }, [
                    _createVNode(PersonCard, {
                      ref_for: true,
                      ref_key: "parentCardsRef",
                      ref: parentCardsRef,
                      "person-id": id,
                      layout: rightCardLayoutRef.value,
                      "data-id": id,
                      "data-index": index
                    }, null, 8, ["person-id", "layout", "data-id", "data-index"]),
                    (relatedLoadedRef.value && hasAncestors(id))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["more-indicator", { related: isRelatedParent(id) }])
                        }, [
                          _createVNode(_unref(PlusIcon))
                        ], 2))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_22, [
                  (showMarriageYear(pf.family))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, "m. " + _toDisplayString(getMarriageYear(pf.family)), 1))
                    : _createCommentVNode("", true)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([pf.family.motherId], (id) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: id,
                    class: "parent-fam-spouse"
                  }, [
                    _createVNode(PersonCard, {
                      ref_for: true,
                      ref_key: "parentCardsRef",
                      ref: parentCardsRef,
                      "person-id": id,
                      layout: rightCardLayoutRef.value,
                      "data-id": id,
                      "data-index": index
                    }, null, 8, ["person-id", "layout", "data-id", "data-index"]),
                    (relatedLoadedRef.value && hasAncestors(id))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["more-indicator", { related: isRelatedParent(id) }])
                        }, [
                          _createVNode(_unref(PlusIcon))
                        ], 2))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              (getOtherSpousesOf(pf, _unref(FamilyRelationshipRole).Mother).length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getOtherSpousesOf(pf, _unref(FamilyRelationshipRole).Mother), (id, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: id }, [
                        _createVNode(SpouseConnector, { layout: rightCardLayoutRef.value }, null, 8, ["layout"]),
                        _createVNode(PersonCard, {
                          ref_for: true,
                          ref_key: "otherParentCardsRef",
                          ref: otherParentCardsRef,
                          personId: id,
                          layout: rightCardLayoutRef.value,
                          "data-id": id,
                          "data-index": index
                        }, null, 8, ["personId", "layout", "data-id", "data-index"]),
                        (relatedLoadedRef.value && hasAncestors(id))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["more-indicator", { related: isRelatedParent(id) }])
                            }, [
                              _createVNode(_unref(PlusIcon))
                            ], 2))
                          : _createCommentVNode("", true),
                        _hoisted_25
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("h4", null, [
          _hoisted_27,
          (allSiblingsRef.value.length > 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_28, "(" + _toDisplayString(allSiblingsRef.value.length) + ")", 1))
            : _createCommentVNode("", true),
          (allSiblingsRef.value.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(allSiblingsRef.value.length), 1))
            : _createCommentVNode("", true)
        ]),
        (siblingFamiliesRef.value.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, " None "))
          : _createCommentVNode("", true),
        (showSiblingFamiliesOptionRef.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "siblingBirthOption",
                class: "btn-check",
                name: "siblingOptions",
                value: false,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showSiblingFamiliesRef).value = $event)),
                autocomplete: "off"
              }, null, 512), [
                [_vModelRadio, showSiblingFamiliesRef.value]
              ]),
              _hoisted_32,
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "siblingFamilyOption",
                class: "btn-check",
                name: "siblingOptions",
                value: true,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showSiblingFamiliesRef).value = $event)),
                autocomplete: "off"
              }, null, 512), [
                [_vModelRadio, showSiblingFamiliesRef.value]
              ]),
              _hoisted_33
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("ul", _hoisted_34, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(siblingFamiliesRef.value, (sf) => {
            return (_openBlock(), _createElementBlock("li", {
              key: sf.family.id
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["spouse-family-header", { show: siblingFamiliesRef.value.length > 1 }])
              }, _toDisplayString(getSiblingFamilyName(sf)) + " (" + _toDisplayString(sf.childIds.length) + ") ", 3),
              _createElementVNode("div", {
                class: _normalizeClass(["spouse-family-header", { show: spouseFamiliesWithChildrenRef.value.length > 1 }])
              }, _toDisplayString(getSpouseFamilyName(sf)) + " (" + _toDisplayString(sf.childIds.length) + ") ", 3),
              _createElementVNode("ul", _hoisted_35, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sf.childIds, (id, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: id }, [
                    (relatedLoadedRef.value && hasDescendants(id) && !isPrimaryPerson(id))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["more-indicator", { related: isRelatedChild(id) }])
                        }, [
                          _createVNode(_unref(PlusIcon))
                        ], 2))
                      : _createCommentVNode("", true),
                    _createVNode(PersonCard, {
                      ref_for: true,
                      ref_key: "siblingCardsRef",
                      ref: siblingCardsRef,
                      personId: id,
                      layout: rightCardLayoutRef.value,
                      disabled: isPrimaryPerson(id),
                      "data-id": id,
                      "data-index": index
                    }, null, 8, ["personId", "layout", "disabled", "data-id", "data-index"])
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("ul", _hoisted_37, [
        _createElementVNode("li", _hoisted_38, [
          _createElementVNode("button", _hoisted_39, [
            _createVNode(_unref(StarIcon)),
            _createTextVNode(" Highlights "),
            (personHighlightsRef.value?.getCount())
              ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(personHighlightsRef.value.getCount()), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("li", _hoisted_41, [
          _createElementVNode("button", _hoisted_42, [
            _createVNode(_unref(AlignJustifyIcon)),
            _createTextVNode(" Details ")
          ])
        ]),
        _createElementVNode("li", _hoisted_43, [
          _createElementVNode("button", _hoisted_44, [
            _createVNode(_unref(ImageIcon)),
            _createTextVNode(" Photos & Files "),
            (contentExplorerRef.value?.getCount())
              ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(contentExplorerRef.value.getCount()), 1))
              : _createCommentVNode("", true),
            (contentExplorerRef.value?.hasSocialData())
              ? (_openBlock(), _createElementBlock("span", _hoisted_46))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _createVNode(PersonHighlights, {
            ref_key: "personHighlightsRef",
            ref: personHighlightsRef,
            "person-id": primaryPersonRef.value?.id
          }, null, 8, ["person-id"])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createVNode(AssertionList, {
            "person-id": primaryPersonRef.value?.id,
            "include-related": ""
          }, null, 8, ["person-id"])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createVNode(ContentExplorer, {
            ref_key: "contentExplorerRef",
            ref: contentExplorerRef,
            "person-id": primaryPersonRef.value?.id
          }, null, 8, ["person-id"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createVNode(Earth, {
        ref_key: "earthRef",
        ref: earthRef,
        mode: earthModeRef.value,
        "onUpdate:mode": _cache[5] || (_cache[5] = ($event: any) => ((earthModeRef).value = $event))
      }, null, 8, ["mode"])
    ])
  ]))
}
}

})